import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'app/core/http/url.service';
import { stringWrapper } from 'app/core/kh-utils/kh-utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SolutionFeedbackService {

  constructor(
    public readonly httpClient: HttpClient,
    public readonly urlService: UrlService) {
  }

  public updateMyFavouriteNo(attemptId: string, attemptItemOrder: number, myFavouriteNo: 'UndoMyFavouriteNo' | 'MyFavouriteNo'): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('Teacher/SolutionFeedback', attemptId, attemptItemOrder.toString(), myFavouriteNo);

    return this.httpClient.put<unknown>(url, {MyFavouriteNo: myFavouriteNo});
  }

  public updateSolutionLike(attemptId: string, attemptItemOrder: number, option: 'Unlike' | 'Like'): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('Teacher/SolutionFeedback', attemptId, attemptItemOrder.toString(), option);

    return this.httpClient.put<unknown>(url, {});
  }

  public rotateSolution(solutionFileId: string): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('Teacher/Solution', solutionFileId, 'Rotate');

    return this.httpClient.post<unknown>(url, {});
  }

  public deleteSolution(attemptId: string, attemptItemOrder: number): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('Teacher/SolutionFeedback', attemptId, attemptItemOrder.toString());

    return this.httpClient.delete<unknown>(url, {});
  }

  public setSolutionComment(attemptId: string, attemptItemOrder: number, teacherComments = ''): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('Teacher/SolutionFeedback', attemptId, attemptItemOrder.toString(), 'Comment');

    return this.httpClient.post<unknown>(url, stringWrapper(teacherComments));
  }
}
